import { useCallback, useEffect, useState } from 'react';

import { Configs, Player } from '../../../types';

type VideoPosterProps = {
  player: Player | null;
  configs: Configs;
  startTime?: number;
  posterUrl?: string;
};

const useVideoPoster = ({ startTime, player, posterUrl, configs: { end } }: VideoPosterProps) => {
  const [showPoster, setShowPoster] = useState(!!posterUrl && !startTime);

  const onEnded = useCallback(() => {
    setShowPoster(true);
  }, []);

  const onPlaying = useCallback(() => {
    setShowPoster(false);
  }, []);

  const onSeeking = useCallback(() => {
    showPoster && setShowPoster(false);
  }, [showPoster]);

  useEffect(() => {
    if (!player || !posterUrl) return;

    player.on('playing', onPlaying);

    const showPosterAfterEnd = end === 'showThumbnail';

    showPosterAfterEnd && player.on('ended', onEnded);

    player.on('seeking', onSeeking);

    return () => {
      player.off('ended', onEnded);
      player.off('seeking', onSeeking);
      player.off('playing', onPlaying);
    };
  }, [player]);

  return [showPoster, setShowPoster] as const;
};

export default useVideoPoster;
